import React from 'react';
import Badge from '../common/Badge';
import Button from '../common/Button';
import { formatNumber, formatCurrency } from '../../utils/formatters';

const PositionCard = ({ position, flashingCells }) => {
  const isProfit = position.profitLoss >= 0;
  const profitColor = isProfit ? 'text-green-500' : 'text-red-500';
  const bgColor = isProfit ? 'bg-green-500/10' : 'bg-red-500/10';

  return (
    <div className={`rounded-lg p-4 mb-3 border ${isProfit ? 'border-green-500/20' : 'border-red-500/20'} ${bgColor}`}>
      {/* 헤더 */}
      <div className="flex justify-between items-start mb-3">
        <h3 className="font-bold text-lg">{position.symbol}</h3>
        <Badge variant={position.direction === 'Long' ? 'success' : 'danger'}>
          {position.direction}
        </Badge>
      </div>

      {/* 포지션 정보 그리드 */}
      <div className="grid grid-cols-2 gap-3 text-sm mb-3">
        <div>
          <div className="text-gray-500 text-xs mb-1">수량</div>
          <div className="font-semibold">{position.quantity}계약</div>
        </div>
        <div>
          <div className="text-gray-500 text-xs mb-1">평균가</div>
          <div className="font-semibold">{formatNumber(position.avgPrice)}</div>
        </div>
        <div>
          <div className="text-gray-500 text-xs mb-1">현재가</div>
          <div className={`font-semibold ${flashingCells[position.id] ? 'flash' : ''}`}>
            {formatNumber(position.currentPrice)}
          </div>
        </div>
        <div>
          <div className="text-gray-500 text-xs mb-1">평가손익</div>
          <div className={`font-bold ${profitColor}`}>
            {formatCurrency(position.profitLoss)}
          </div>
        </div>
      </div>

      {/* 수익률 표시 */}
      <div className="mb-3 pb-3 border-b border-gray-700">
        <div className="flex justify-between items-center">
          <span className="text-xs text-gray-500">수익률</span>
          <span className={`font-bold text-lg ${profitColor}`}>
            {isProfit ? '+' : ''}{((position.profitLoss / (position.avgPrice * position.quantity * 250000)) * 100).toFixed(2)}%
          </span>
        </div>
      </div>

      {/* 청산 버튼 */}
      <Button
        variant="secondary"
        size="sm"
        className="w-full"
        disabled
      >
        청산 (비활성)
      </Button>
    </div>
  );
};

export default PositionCard;
